import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  actions: [],
  applicants: [],
  interviews: null,
  loading: false,
  total: 0,
};

function onLoad(state) {
  return { ...state, loading: true, isEdit: false };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, actions: actionsList, filters } = payload;

  return {
    ...state,
    interviews: data, // sortData(data),
    actions: actionsList,
    total,
    filteredTotal,
    filters,
    loading: false,
  };
}

function onClearStore(state) {
  return { ...initState, interviews: state.interviews };
}

function onChangeData(state, { payload }) {
  return { ...state, [payload.prop]: payload.value };
}

function onCheckInSuccess(state, { payload }) {
  const interviews = [...state.interviews];
  interviews.map(item => {
    if (item.applicant.id === payload.interview.applicant.id) {
      item.checkin_time = new Date();
    }

    return item;
  });

  return { ...state, interviews }; // : sortData(interviews)
}

function onRemoveCheckInSuccess(state, { payload }) {
  const interviews = [...state.interviews];
  interviews.map(item => {
    if (item.applicant.id === payload.interview.applicant.id) {
      item.checkin_time = null;
    }

    return item;
  });

  return { ...state, interviews }; // : sortData(interviews)
}

function onLoadApplicantsListSuccess(state, { payload }) {
  return { ...state, applicants: payload.applicants };
}

export default createReducer(initState, {
  [actions.CHANGE_DATA]: onChangeData,
  [actions.CHECK_IN_SUCCESS]: onCheckInSuccess,
  [actions.REMOVE_CHECK_IN_SUCCESS]: onRemoveCheckInSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.LOAD]: onLoad,
  [actions.LOAD_APPLICANTS_LIST_SUCCESS]: onLoadApplicantsListSuccess,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
});
